import React, { useEffect, useState } from "react";
import classNames from "classnames";

import { getAllChats } from '../../actions/chat.action'
import { connect, useSelector } from "react-redux";
import { getSender } from "../../utils/utility";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ActiveChats from "./ActiveChats";

function ChatBox({ socketConnected, user, getAllChats, chats }) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const [activeChats, setActiveChats] = useState([]);
  const loggedInUser = useSelector(state => state?.auth?.user);

  useEffect(() => {
    getAllChats(user?._id);
  }, []);

  const handleUserSelection = (user) => {
    const { op } = user;
    setActiveChats(prevSelectedUsers => {
      // Check if the user is already in the selected list
      if (prevSelectedUsers.some(selectedUser => selectedUser.op === op)) {
        return prevSelectedUsers;
      }

      if (prevSelectedUsers.length >= 3) {
        return [...prevSelectedUsers.slice(1), user];
      }
      return [...prevSelectedUsers, user];
    });
  };

  const removeUserById = (id) => {
    setActiveChats(prevActiveUsers =>
      prevActiveUsers.filter(user => user.op !== id)
    );
  };

  // const handleChat = async () => {
  //   const res = await axios.post("/api/chats", {
  //     tripOwner: "636e8c57b539cf0720193b6d", // will get this from logged in user data
  //     agent: "636fb2405abcae00169e0124", // will get this from comment
  //     chatContent: [
  //       {
  //         chat,
  //         sender: "636fb2405abcae00169e0124",
  //       },
  //     ],
  //   });
  //   setChat("");
  // };

  return (
    <>
      <ActiveChats
        activeChats={activeChats}
        removeUserById={removeUserById}
      />
      <div className={classNames("chatbox", { open: expanded })}>
        <div
          className="chatHeader navbar-menu"
          onClick={() => setExpanded(!expanded)}
        >
          <div className="navbar-start">{socketConnected && <div className="online"></div>} {t("MESSAGES")}</div>
          <div className="navbar-end">
            <button
              style={{
                justifyItems: "flex-end",
                border: "none",
                background: "none",
              }}
            >
              {expanded ? (
                <i className="fas fa-angle-down" />
              ) : (
                <i className="fas fa-angle-up" />
              )}
            </button>
          </div>
        </div>
        <div className="chat-content">
          <div className="columns mt-5 px-4">
            <i className="far fa-comments"></i>
            <h3 style={{ fontSize: '18px' }}>{t("WELCOME_TO_CHATS")}</h3>
          </div>
          {chats.length ? (
            <ul id="chat-buddies" style={{ overflowY: 'auto', height: '270px' }}>
              {chats.map((chat, index) => {
                const op = chat.users[0]?._id === loggedInUser?._id ? chat.users[1]?._id : chat.users[0]?._id;
                const opName = chat.users[0]?._id === loggedInUser?._id ? chat.users[1]?.name : chat.users[0]?.name;
                return (
                  <li key={index}>
                    <button
                      className="button is-link is-outlined is-fullwidth my-2 has-text-left"
                      onClick={() => handleUserSelection({ loggedInUser, op, opName })}
                    // onClick={() => {
                    //   // refactor here to remove repetative users and maximum 3 users at a time.
                    //   setActiveChats([...activeChats, {
                    //     loggedInUser: loggedInUser?._id,
                    //     otherParty: chat.users[0]?._id === loggedInUser?._id ? chat.users[1]?._id : chat.users[0]?._id,
                    //     otherPartyName: chat.users[0]?._id === loggedInUser?._id ? chat.users[1]?.name : chat.users[0]?.name
                    //   }])
                    // }}
                    >
                      <div className="offline"></div> {getSender(loggedInUser, chat.users)}
                    </button>
                  </li>
                );
              }
              )}
            </ul>
          ) : (
            <>
              <p>Start connecting to others by <Link to="/browse-agents">browsing agents</Link> or, <Link to="/create-new-trip">posting a trip</Link></p>
            </>
          )}
        </div>
      </div >

    </>
  );
}

const mapStateToProps = state => {
  return { user: state?.auth?.user, chats: state?.chat?.chats }
};


export default connect(mapStateToProps, { getAllChats })(ChatBox);
